import React, { Fragment } from 'react';
import { ChevronUpIconSmall, ExternalLinkIconSmall } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
var Logo = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-agent-recommendations/static/rma-logo_072ab9ea.svg";
import * as styles from './footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ShowMoreFewerButton = _ref => {
  var displayedReviews = _ref.displayedReviews,
    totalReviews = _ref.totalReviews,
    isExpanded = _ref.isExpanded,
    onButtonClick = _ref.onButtonClick,
    className = _ref.className;
  return ___EmotionJSX(Fragment, null, totalReviews > displayedReviews && ___EmotionJSX(Button, {
    className: className,
    appearance: "outline",
    iconPosition: "right",
    icon: ___EmotionJSX(ChevronUpIconSmall, {
      css: styles.buttonIcon(isExpanded)
    }),
    onClick: onButtonClick
  }, isExpanded ? 'Show fewer reviews' : 'Load more reviews'));
};
var Footer = _ref2 => {
  var displayedReviews = _ref2.displayedReviews,
    totalReviews = _ref2.totalReviews,
    url = _ref2.url,
    isExpanded = _ref2.isExpanded,
    onButtonClick = _ref2.onButtonClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var openReviewProfile = () => {
    sendEvent('open-review-profile');
    var win = window.open(url, '_blank');
    if (win) {
      win.opener = null;
    }
  };
  return ___EmotionJSX("div", {
    css: styles.footer
  }, ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.countPlug
  }, ___EmotionJSX("div", {
    css: styles.count
  }, displayedReviews, " of ", totalReviews, " reviews"), ___EmotionJSX("div", {
    css: styles.plug
  }, ___EmotionJSX("div", {
    css: styles.plugText
  }, "Recommendations provided by"), ___EmotionJSX("img", {
    css: styles.logo,
    alt: "",
    src: Logo
  })), ___EmotionJSX(ShowMoreFewerButton, {
    css: styles.buttonMobile,
    displayedReviews: displayedReviews,
    totalReviews: totalReviews,
    isExpanded: isExpanded,
    onButtonClick: onButtonClick
  })), url && ___EmotionJSX(Button, {
    iconPosition: "right",
    appearance: "ghost",
    icon: ___EmotionJSX(ExternalLinkIconSmall, null),
    onClick: openReviewProfile
  }, "View all reviews on Rate My Agent")), ___EmotionJSX(ShowMoreFewerButton, {
    css: styles.button,
    displayedReviews: displayedReviews,
    totalReviews: totalReviews,
    isExpanded: isExpanded,
    onButtonClick: onButtonClick
  }));
};
export { Footer };